import { Component, ElementRef, HostBinding } from '@angular/core';
import { IWizItemRenderer, WizDatasource, WizBaseCollector, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { VisionKey } from '@wizeoo/akm-message-lib';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { Model } from 'src/app/model/model';

/**
 * rendu d'une clé de step
 */
@Component({
  selector: 'step-key-renderer',
  templateUrl: './step-key.renderer.html',
})
export class StepKeyRenderer implements IWizItemRenderer<null, {vision: VisionVO, visionKey:VisionKey}> {
  @HostBinding('style.width') width: string = '100%';

  constructor(public elementRef: ElementRef) {}

  data: {vision: VisionVO, visionKey:VisionKey};
  owner: WizBaseCollector;

  public get vision(): VisionVO{
    return this.data.vision;
  }

  public get visionKey(): VisionKey{
    return this.data.visionKey;
  }

  public get orderAndlabel(): string {
    let label: string = Model.getInstance().visionEngine.getVisionKeyLabel(this.vision, this.visionKey);
    return this.visionKey.order + ' - ' + label;
  }

  public mayUp(): boolean {
    return this.visionKey.stepLevel > 1;
  }

  public mayDown(): boolean {
    return this.visionKey.stepLevel < 10;
  }

  public doUp(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();

    const toUpdate: VisionKey[] = [];
    const ds: WizDatasource<{vision: VisionVO, visionKey:VisionKey}> = this.owner.wizDataProvider;
    ds.getWorkedSource().forEach((item: {vision: VisionVO, visionKey:VisionKey}) => {
      if (item.visionKey.order <= this.visionKey.order) {
        item.visionKey.stepLevel--;
        toUpdate.push(item.visionKey);
      }
    });

    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.KEY_STEP_UP, toUpdate));
  }

  public doDown(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();

    const toUpdate: VisionKey[] = [];
    const ds: WizDatasource<{vision: VisionVO, visionKey:VisionKey}> = this.owner.wizDataProvider;
    ds.getWorkedSource().forEach((item: {vision: VisionVO, visionKey:VisionKey}) => {
      if (item.visionKey.order >= this.visionKey.order) {
        item.visionKey.stepLevel++;
        toUpdate.push(item.visionKey);
      }
    });
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.KEY_STEP_DOWN, toUpdate));
  }
}
